import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.min.css";
import "../src/CSS/Variable.css";
import "../src/CSS/textHederSection.css";
import "./index.css";
import "./Components/common/header.css";
import "../src/Pages/Auth/Form.css";
import "../src/CSS/Loding.css";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { AuthProvider } from "./Pages/context/AuthProvider";

const savedTheme = localStorage.getItem("theme");
if (savedTheme === "dark") {
  document.body.classList.add("dark");
  document.documentElement.classList.add("dark");
  document.documentElement.setAttribute("data-theme", "dark");
} else {
  document.body.classList.remove("dark");
  document.documentElement.classList.remove("dark");
  document.documentElement.setAttribute("data-theme", "light");
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .getRegistrations()
    .then((registrations) => {
      for (let registration of registrations) {
        registration.unregister();
      }
    })
    .catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <AuthProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </AuthProvider>
);
